import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { acme } from '../../theme/acmeTheme';
import IconButton from './IconButton';
import { Menu } from './Menu';

export const tableActionsMenuAnchorProps = {
  transformOrigin: { horizontal: 'right', vertical: 'top' },
  anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
};

export const destructiveMenuItemSx = {
  color: acme.colors.destructive,
};

export function TableActionsMenuButton({
  ariaLabel = 'Actions',
  onClick,
  ...props
}) {
  return (
    <IconButton
      size="small"
      aria-label={ariaLabel}
      onClick={onClick}
      {...props}
    >
      <MenuIcon fontSize="small" />
    </IconButton>
  );
}

export function TableActionsMenu({
  anchorEl,
  open,
  onClose,
  children,
  ...props
}) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      onClick={(e) => e.stopPropagation()}
      {...tableActionsMenuAnchorProps}
      {...props}
    >
      {children}
    </Menu>
  );
}

export function stopTableRowClick(event) {
  event.stopPropagation();
}
